import { Text } from '@servicetitan/anvil2';
import { CSSProperties, isValidElement, ReactNode } from 'react';

/**
 * Component to display a labeled data item
 */
interface DataItemProps {
    label: string;
    text: ReactNode | string | null | undefined;
    details?: string | null | undefined;
    style?: CSSProperties;
}

export const DataItem = ({ label, text, details, style }: DataItemProps) => {
    return (
        <div style={style}>
            <Text variant="eyebrow">{label}</Text>
            {isValidElement<any>(text) ||
            (text && typeof text === 'object' && Symbol.iterator in text) ? (
                <div>{text}</div>
            ) : (
                /* eslint-disable-next-line @typescript-eslint/naming-convention */
                <Text aria-label={label} dangerouslySetInnerHTML={{ __html: String(text ?? '') }} />
            )}
            {details && (
                <Text variant="body" subdued size="small">
                    {details}
                </Text>
            )}
        </div>
    );
};
